module.exports = __webpack_public_path__ + "img/whatiskadena.a1948f2d.svg";